var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 300 300",
    height: "300px",
    id: "Layer_1",
    viewBox: "0 0 300 300",
    width: "300px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.755,14.989c-74.779,0-135.402,60.625-135.402,135.41c0,74.781,60.623,135.413,135.402,135.413   c74.787,0,135.414-60.632,135.414-135.413C286.169,75.614,225.542,14.989,150.755,14.989z M150.755,266.663   c-64.204,0-116.262-52.055-116.262-116.264s52.059-116.26,116.262-116.26c64.211,0,116.261,52.05,116.261,116.26   S214.967,266.663,150.755,266.663z",
    fill: "#BD3C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.508,150.399c0,57.849-46.897,104.743-104.749,104.743c-57.852,0-104.741-46.894-104.741-104.743   S92.908,45.652,150.759,45.652C208.61,45.652,255.508,92.55,255.508,150.399z",
    fill: "#BD3C27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,150.3l-35.657-61.574l-35.505,61.671l-35.497,61.677l71.163-0.101l71.163-0.101L186.26,150.3z    M159.799,123.211l-2.499,51.527h-12.965l-2.506-51.527H159.799z M150.819,201.132h-0.116c-6.022,0-10.125-4.441-10.125-10.354   c0-6.143,4.208-10.358,10.242-10.358c6.022,0,10.009,4.212,10.121,10.358C160.94,196.69,156.958,201.132,150.819,201.132z",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.84d2dfac84f4b6e9fa21850de1880e1c.svg";
export { ForwardRef as ReactComponent };